import { render, staticRenderFns } from "./CreateWorkType.vue?vue&type=template&id=47688a09&"
import script from "./CreateWorkType.vue?vue&type=script&lang=js&"
export * from "./CreateWorkType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports